import { AWSEmailConfigurationStatus } from "models/email-domain-validation";
import { doGet } from "../request";

export const adminDoGetEmailDomainValidation = async () => {
  const status = await doGet<AWSEmailConfigurationStatus>(
    `/admin/settings/email-domain-validation`,
  );
  return status;
};
